import { IPoi } from "~/interfaces";
import { _ } from "~/i18n";
import Content from "./content";
import { createBookingLink } from "~/ui/booking-link";

export default class BookingLink extends Content {
	_build() {
		this._dom.container.classList.add("content-booking-link");
		this._dom.container.classList.add("empty");

		if (this._data.linkProm) {
			this._data.linkProm.promise.then(bookingLinkData => {
				if (!bookingLinkData.link) {
					return;
				}

				this._dom.container.classList.remove("empty");

				const poiData: IPoi = this._data.data;
				const bookingLink = createBookingLink({
					title: _("bookingLink.findAccomArea"),
					link: bookingLinkData.link,
					onClick: () => {
						Mapy.getComponent("logger").log("clickBooking", {
							source: poiData.source,
							id: poiData.id,
							name: poiData.title,
							typeId: 6,
							placeId: 1,
							target: "booking",
						});
					},
				});

				this._dom.container.append(bookingLink);
			}, () => {});
		}
	}
}
